export const lightTheme = {
  id: 'light',
  // color
  primary: '#ddf4ff',
  success: '#e6ffec',
  warning: '#fff8c5',
  danger: '#ffebe9',
  toggleIcon: '#c69026',
  // background
  primaryBg: '#ffffff',
  secondaryBg: '#f6f8fa',
  borderColor: '#ededed',
  // text
  text: '#24292f',
  mutedText: '#b1b1b1',
  headings: '#000000',
  accentHeadings: '#ffffff',
  links: '#0969da',
  // button primary
  btnPrimaryText: '#0969da',
  btnPrimaryTextHover: '#ffffff',
  btnPrimaryBg: '#ddf4ff',
  btnPrimaryBgHover: '#0969da',
  // button danger
  btnDangerBg: 'rgba(229,83,75,0.7)',
  btnDangerBgHover: 'rgba(229,83,75,0.6)',
  // opposite color
  oppositePrimaryBg: '#22272e',
  oppositeSecondaryBg: '#2d333b',
  oppositeText: '#adbac7',
  // etc
  transitionTime: '0.2s',
}
